import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'formik';
import styled from '@emotion/styled';
import TextField from '../../app/form/formik/text';
import Radio from '../../app/form/formik/radio';
// import DateField from '../../app/form/formik/date';
import { getGenderOptions } from '../../collections/edit/child-journal/options';
import { Text, Flex } from 'rebass';
// import CoverField from 'app/form/formik/cover/index';

const StyledForm = styled(Form)`
  display: grid;
  grid-gap: 10px;
  padding: 10px;
`;

const label = (text, isRequired) => <Text
  sx={{
    color: "codGrey",
    fontFeatureSettings: 'liga off, calt off',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px', /* 142.857% */
    letterSpacing: '-0.084px',
  }}> {text} {isRequired && <span style={{ color: 'red' }}>*</span >}</Text >

const ChildJournalForm = ({ }) => (
  <StyledForm autoComplete="off">
    {/* <Flex justifyContent="center" flexDirection="column" m="auto">
      <Field
        name="cover"
        component={CoverField}
        width={150}
        circular
      />
    </Flex> */}
    <Field
      component={TextField}
      name="first-name-noac"
      label={label("Baby's first name", true)}
      // subText="Leave blank if undecided yet"
      showError
      placeholder="First Name"
      mb={1}
    />
    {/* <Field
      component={DateField}
      name="date-of-birth"
      label={label("Birthdate or due date", true)}
      subText="You can always change this later"
      placeholder="Birthday"
      my={1}
    /> */}
    <Field
      component={Radio}
      name="gender"
      label={label('Baby is a...', true)}
      placeholder="Gender"
      options={getGenderOptions('child-journals')}
      my={1}
    />
    {/* <Field
      component={Radio}
      name="subject-pronoun"
      label={label('Baby’s pronouns', true)}
      options={chroniclePronouns('child-journals')}
      my={1}
    /> */}
    {/* <Button type="submit" primary disabled={!isValid || isSubmitting}>
      Save
    </Button>
    <StyledButtonLink muted to="/collections">
      Cancel
    </StyledButtonLink> */}
  </StyledForm>
);

ChildJournalForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
};

export default ChildJournalForm;
